import React from "react";
import classNames from 'classnames';
import Box from "../Box";
/**
 *
 * Simple rectangular container.
 *
 *  ```javascript
 *      import { Card } from 'miever_components';
 *  ```
 * @param ICardProps
 * @returns
 */
var Card = function (_a) {
    var title = _a.title, subTitle = _a.subTitle, children = _a.children, style = _a.style, className = _a.className, _b = _a.hoverable, hoverable = _b === void 0 ? false : _b;
    var classes = classNames('card', className, {
        'card-hover': hoverable
    });
    return (React.createElement(Box, { className: classes, style: style },
        React.createElement(Box, { className: "card-header" },
            React.createElement(Box, null, title),
            subTitle && (React.createElement(Box, { className: "card-subtitle" }, subTitle))),
        React.createElement(Box, { className: "card-content" }, children)));
};
export default Card;
